// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QJ8V","placeholdersHeader":"styles_placeholdersHeader__1-052","editorStyle":"styles_editorStyle__MR96T","placeholdersBox":"styles_placeholdersBox__1d4EH"};